var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.cardClasses,
      attrs: { "data-qa": `timeline-card:${_vm.type}` },
    },
    [
      _c(
        "div",
        {
          class: _vm.badgeModel.classes,
          attrs: { "data-qa": "timeline-card-elements:Badge" },
        },
        [
          _c("base-icon", {
            staticClass: "_mr-1",
            attrs: { name: _vm.badgeModel.icon },
          }),
          _vm._v(" " + _vm._s(_vm.badgeModel.text) + "\n    "),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.cardContentClasses,
          attrs: { "data-qa": "timeline-card-content" },
        },
        [
          _c(
            "base-heading",
            { staticClass: "gfu-hd gfu-hd--h4", attrs: { tag: "h4" } },
            [_vm._v(_vm._s(_vm.status))]
          ),
          _vm._v(" "),
          _vm.copy
            ? _c(
                "localize",
                {
                  staticClass: "_mb-a",
                  attrs: {
                    resource: _vm.copy,
                    "data-qa": "timeline-card-elements:Copy",
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "gfu-link gfu-link--accent",
                      attrs: {
                        "format-key": "0",
                        href: _vm.learnMoreUrl,
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.learnMoreLabel) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("strong", { attrs: { "format-key": "1" } }, [
                    _vm._v(_vm._s(_vm.backerNumber)),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isActionVisible || _vm.isAdditionalInfoVisible
            ? _c(
                "div",
                { staticClass: "_mt-2 _flex _gap-1" },
                [
                  _vm.isAdditionalInfoIconVisible
                    ? _c("base-icon", {
                        attrs: { name: _vm.additionalInfoIconName },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "_flexcol" },
                    [
                      _vm.isAdditionalInfoVisible
                        ? _c(
                            _vm.additionalInfoComponent.component,
                            _vm._b(
                              {
                                tag: "component",
                                class: _vm.additionalInfoComponent.classes,
                                attrs: {
                                  "data-qa":
                                    "timeline-card-elements:AdditionalInfo",
                                },
                              },
                              "component",
                              _vm.additionalInfoComponent.props,
                              false
                            ),
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.additionalInfoComponent.text) +
                                  "\n                    "
                              ),
                              _vm.tooltipText
                                ? _c("tooltip", {
                                    attrs: {
                                      "icon-name": "info",
                                      text: _vm.tooltipText,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isActionVisible
                        ? _c(
                            _vm.action.component,
                            _vm._b(
                              {
                                tag: "component",
                                staticClass: "_tc--accent _ttl _pa-0 gfu-link",
                                attrs: {
                                  "data-qa": "timeline-card-elements:Action",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.sendAnalyticsEvent.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              "component",
                              _vm.action.props,
                              false
                            ),
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.action.text) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }